import * as fromDatatype from '../datatype-library';

export interface bl_fi_default_bank_stmt_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    payee_or_payor_name: fromDatatype.VarcharDatatypeInterface;
    payee_or_payor_name_error: fromDatatype.VarcharDatatypeInterface;
    recipient_reference: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.VarcharDatatypeInterface;
    txn_date_error: fromDatatype.VarcharDatatypeInterface;
    amount: fromDatatype.VarcharDatatypeInterface;
    amount_error: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    bic_or_swift_code: fromDatatype.VarcharDatatypeInterface;
    iban: fromDatatype.VarcharDatatypeInterface;
    bank_account_number: fromDatatype.VarcharDatatypeInterface;
    bank_reference_number: fromDatatype.VarcharDatatypeInterface;
    reference_number: fromDatatype.VarcharDatatypeInterface;
    reference_number2: fromDatatype.VarcharDatatypeInterface;
    reference_number3: fromDatatype.VarcharDatatypeInterface;
    reference_number4: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_default_bank_stmt_import_file_helper_RowClass implements bl_fi_default_bank_stmt_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    payee_or_payor_name: fromDatatype.VarcharDatatypeInterface;
    payee_or_payor_name_error: fromDatatype.VarcharDatatypeInterface;
    recipient_reference: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.VarcharDatatypeInterface;
    txn_date_error: fromDatatype.VarcharDatatypeInterface;
    amount: fromDatatype.VarcharDatatypeInterface;
    amount_error: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    bic_or_swift_code: fromDatatype.VarcharDatatypeInterface;
    iban: fromDatatype.VarcharDatatypeInterface;
    bank_account_number: fromDatatype.VarcharDatatypeInterface;
    bank_reference_number: fromDatatype.VarcharDatatypeInterface;
    reference_number: fromDatatype.VarcharDatatypeInterface;
    reference_number2: fromDatatype.VarcharDatatypeInterface;
    reference_number3: fromDatatype.VarcharDatatypeInterface;
    reference_number4: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
